const OrderlineAddRemove = {
  // const cartBtn = document.querySelector(".quicknav__cart");
  // const cartBtnTotal = document.querySelector(".quicknav__cart span");

  init(target) {
    const form = target
    const minusBtn = target.querySelector('.button__counter--minus')
    const addBtn = target.querySelector('.button__counter--add')
    if (minusBtn) {
      minusBtn.addEventListener('click', () => this.submit(form, minusBtn, addBtn))
    }
    if (addBtn) {
      addBtn.addEventListener('click', () => this.submit(form, minusBtn, addBtn))
    }
  },

  async submit(form, minusBtn, addBtn) {
    const callout = form.querySelectorAll('.callout')
    const data = new FormData(form)
    const action = form.getAttribute('action')
    const formMethod = form.getAttribute('method')

    if (callout) {
      callout.forEach((el) => el.remove())
    }

    minusBtn.disabled = true
    addBtn.disabled = true

    fetch(action, {
      method: formMethod,
      body: data,
    })
      .then((res) => res.json())
      .then(() => {
        location.reload()
      })
      .catch((ex) => {
        console.log(form, `Server error: ${ex}`, 'error')
      })
  },
}

export default OrderlineAddRemove
